import { Link, Navigate, Outlet } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spinner } from '@/components/ui';
import { useSession } from '@/features/session/SessionProvider';
import { WorkspaceProvider } from '@/features/session/WorkspaceProvider';

// The shell (nav, palette, sheets) is only needed after sign-in, so anonymous visitors never download it.
const AppShell = lazy(() => import('@/components/shell/AppShell').then((m) => ({ default: m.AppShell })));

export function Splash() {
  return (
    <div className="grid min-h-dvh place-items-center">
      <Spinner className="size-6 text-accent" />
    </div>
  );
}

export function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="grid min-h-[60dvh] place-items-center gap-4 p-6 text-center">
      <p className="text-lg">{t('pages.notFound')}</p>
      <Button asChild><Link to="/">{t('nav.home')}</Link></Button>
    </div>
  );
}

export function PublicLayout() {
  const { status } = useSession();
  if (status === 'loading') return <Splash />;
  if (status === 'authenticated') return <Navigate to="/" />;
  return <Outlet />;
}

export function AuthedLayout() {
  const { status } = useSession();
  if (status === 'loading') return <Splash />;
  if (status === 'anonymous') return <Navigate to="/login" />;
  return (
    <WorkspaceProvider fallback={<Splash />}>
      <Suspense fallback={<Splash />}>
        <AppShell />
      </Suspense>
    </WorkspaceProvider>
  );
}
